<app-table
    translatePrefix="sickNotes.submissionHistory."
    [columns]="columns"
    [items]="items()"
    [hideCheckboxes]="true"
    [showSearchBar]="false"
>
</app-table>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons [primaryButtonVisibility]="false"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
